export const TRAVELER_DEFAULTS = {
  rooms: {
    min: 1,
    max: 4,
  },
  travellers: {
    min: 1,
    max: 9,
  },
  travellersPerRoom: {
    min: 1,
    max: 4,
  },
};
